"use client";

import {
  BOX_SHADOW_SIZE_LARGE,
  BRAND_COLOR,
  META_AUSTRALIAS_NUMBER_1,
} from "@/app/layout/LayoutConstants";
import PillButton from "@/app/shared/PillButton";
import { Box, styled, Typography } from "@mui/material";
import Link from "next/link";
import SearchIcon from "@mui/icons-material/Search";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import Image, { StaticImageData } from "next/image";
import { TrackedLink } from "../shared/TrackedLink";

const MegaButton = styled(PillButton)(({ theme }) =>
  theme.unstable_sx({
    boxShadow: BOX_SHADOW_SIZE_LARGE,
    padding: theme.spacing(1, 4),
    width: "200px",
    height: "initial",
    "&": {
      fontSize: "1.5rem",
      [theme.breakpoints.down("md")]: {
        fontSize: "1.2rem",
        width: "140px",
      },
      ".MuiButton-icon": {
        fontSize: "inherit",
        ".MuiSvgIcon-root": {
          fontSize: "inherit",
        },
      },
    },
  }),
);

export interface HomepageHeroImage {
  image: StaticImageData;
  href?: string;
  title: string;
  height?: string;
}

export default function HomepageHero({ image }: { image: HomepageHeroImage }) {
  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "grey.100",
      }}
    >
      <Box
        sx={{
          position: "relative",
          height: image.height || "300px",
          width: "100%",
          filter: "brightness(0.8)",
        }}
      >
        <Box
          component={image.href ? TrackedLink : "div"}
          href={image.href || undefined}
          label={image.title || "NONE"}
        >
          <Image
            src={image.image}
            alt={image.title}
            layout="fill"
            objectFit="cover"
          />
        </Box>
      </Box>
      <Box
        sx={(theme) => ({
          display: "flex",
          flexDirection: "column",
          gap: 4,
          alignItems: "center",
          boxShadow: 10,
          backgroundColor: "white",
          padding: theme.spacing(4, 8),
          margin: 2,
          marginTop: -4,
          borderRadius: 10,
          zIndex: 1,
          [theme.breakpoints.down("md")]: {
            padding: theme.spacing(2, 2),
            gap: 2,
          },
        })}
      >
        <Typography
          variant="h4"
          component="h1"
          sx={(theme) => ({
            textAlign: "center",
            margin: "0 auto",
            [theme.breakpoints.down("md")]: {
              fontSize: "1.8rem",
            },
          })}
        >
          {META_AUSTRALIAS_NUMBER_1}
        </Typography>
        <Box
          sx={(theme) => ({
            display: "flex",
            gap: 4,
            [theme.breakpoints.down("md")]: {
              gap: 2,
            },
          })}
        >
          <Link href="/for-sale/everything-equine">
            <MegaButton
              startIcon={<SearchIcon />}
              primary
              sx={{
                backgroundColor: BRAND_COLOR,
              }}
            >
              Search
            </MegaButton>
          </Link>
          <Link href="/sell">
            <MegaButton
              startIcon={<HandshakeOutlinedIcon />}
              sx={{
                backgroundColor: "rgba(0, 0, 0, 0.7)",
                color: "white",
                // borderColor: 'white',
                "&": {
                  color: "white",
                  ".MuiButton-icon": {
                    color: "white",
                    ".MuiSvgIcon-root": {
                      color: "white",
                    },
                  },
                },
              }}
            >
              Sell
            </MegaButton>
          </Link>
        </Box>
      </Box>
    </Box>
  );
}
